var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWifiHigh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.833 27C17.6614 27 18.333 26.3284 18.333 25.5C18.333 24.6716 17.6614 24 16.833 24C16.0046 24 15.333 24.6716 15.333 25.5C15.333 26.3284 16.0046 27 16.833 27Z",
    fill: "#E85D04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.833 11.6488C26.1676 8.64257 21.5735 6.99963 16.833 6.99963C12.0925 6.99963 7.49845 8.64257 3.83301 11.6488",
    stroke: "#E85D04",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.833 16.125C23.2714 14.0972 20.1001 12.9938 16.833 12.9938C13.5659 12.9938 10.3946 14.0972 7.83301 16.125",
    stroke: "#E85D04",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.833 20.625C20.3801 19.5681 18.6296 18.9988 16.833 18.9988C15.0364 18.9988 13.2859 19.5681 11.833 20.625",
    stroke: "#E85D04",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiHigh);
export default __webpack_public_path__ + "static/media/WifiHigh.24512c95ed6fafc45feb8e8a76ce4ee3.svg";
export { ForwardRef as ReactComponent };